import {defaultHandlerCatch, defaultHandlerResolver, promisifyImage} from "./helpers";
import {photolabTask} from "../api";
import Processing from "../Processing";
import groups from "../config/groups";
import {PhotolabTaskBuilder} from "@vicman-wi/photolab-api-js";

const tasksCache = {};

function photolabTaskHelper(creative, taskName, taskConfig, options) {
  const taskCacheKey = JSON.stringify(taskConfig);
  const _options = Object.assign({
    timeout: 1000,
    interval: 1000,
  }, options);

  if (!tasksCache[taskCacheKey]) {
    tasksCache[taskCacheKey] = photolabTask(taskConfig, {
      timeout: _options.timeout,
      interval: _options.interval,
    })
  }

  return tasksCache[taskCacheKey].then((taskResult) => {
    creative.setTask(taskName, taskResult);
    return taskResult;
  }).catch((err) => {
    delete tasksCache[taskCacheKey];
    throw err;
  });
}

/**
 * @param {Processing} processing
 * @param {Creative} creative
 */

export default (processing, creative) => {
    return new Promise(async (resolve, reject) => {
      try {
        const {answers} = processing.getExtra(Processing.EXTRA_QUESTIONS_TASK);
        let gender = answers[0].split(" ").first();

        if (creative.group === groups.D11) {
            gender = gender === "male" ? "man" : "woman";
        }
  
        const promptTaskResult = await photolabTaskHelper(creative, "prompt", new PhotolabTaskBuilder()
          .setLanguage(processing.language)
          .addCollageMethod({
            "@transformationId": "npp_base",
            "@configId": creative.getExtra("config_id"),
            param_sds: creative.getExtra("seed"),
            gender,
          })
          .addImage(processing.file.url)
          .setLanguage(processing.language)
          .build());
  
        await promisifyImage(promptTaskResult.resultUrl);
  
        creative.setFile("raw", promptTaskResult.resultUrl);
        creative.markAsProcessed(promptTaskResult.resultUrl);
  
        defaultHandlerResolver(creative, resolve)();
      } catch (err) {
        defaultHandlerCatch(creative, reject)(err);
      }
    });
  }